<!--水费抄表卡(A4)打印页面-->
<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': true } }">
    <a-spin :spinning="confirmLoading">
      <div class="no-print" style="margin-bottom: 20px;text-align: right;">
        <a-button v-print="'#printCardContent'" ghost type="primary">{{ $t('打印') }}</a-button>
      </div>
      <div id="printCardContent" class="a4-page">
        <table class="info-table no-border-table">
          <colgroup>
            <col style="width: 22%">
            <col style="width: 28%">
            <col style="width: 22%">
            <col style="width: 28%">
          </colgroup>
          <tr>
            <td class="label">{{ $t('表编号') }}：</td>
            <td>{{ model.meterId }}</td>
            <td class="label">{{ $t('注册日期') }}：</td>
            <td>{{ createTimeText }}</td>
          </tr>
        </table>
        <table class="info-table">
          <colgroup>
            <col style="width: 22%">
            <col style="width: 78%">
          </colgroup>
          <tr>
            <td class="label">{{ $t('用户名称') }}：</td>
            <td>{{ model.userName }}</td>
          </tr>
          <tr>
            <td class="label">{{ $t('联系电话') }}：</td>
            <td>{{ model.userPhone }}</td>
          </tr>
          <tr>
            <td class="label">{{ $t('地址') }}：</td>
            <td>{{ userAddrText }}</td>
          </tr>
          <tr>
            <td class="label">{{ $t('上年底数') }}：</td>
            <td class="center">{{ $t('年') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('月') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('日') }}</td>
          </tr>
        </table>
        <table class="month-table">
          <colgroup>
            <col style="width: 11%">
            <col style="width: 11%">
            <col style="width: 20%">
            <col style="width: 20%">
            <col style="width: 20%">
            <col style="width: 20%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('月') }}</th>
              <th>{{ $t('日') }}</th>
              <th>{{ $t('上月表数') }}</th>
              <th>{{ $t('本月表数') }}</th>
              <th>{{ $t('用水量m³') }}</th>
              <th>{{ $t('备注') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="m in 12" :key="m">
              <td class="month-cell">{{ m }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
export default {
  name: 'MeterTagPrintModal',
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      confirmLoading: false,
      disableSubmit: true,
      model: {},
    }
  },
  computed: {
    // 地址与列表展示保持一致：去掉区域名中第一段(至第一个'-')后拼接实际地址
    userAddrText() {
      if (!this.model.userAddr) {
        return ''
      }
      if (this.model.userAreaName) {
        let i = this.model.userAreaName.indexOf('-')
        if (i > -1) {
          return this.model.userAreaName.slice(i + 1) + '-' + this.model.userAddr
        }
      }
      return this.model.userAddr
    },
    // 注册日期：格式化为 yyyy年MM月dd日
    createTimeText() {
      if (!this.model.createTime) {
        return ''
      }
      // 兼容 "2026-07-09 11:19:38" / "2026-07-09" / 时间戳
      let d = new Date(this.model.createTime.replace(/-/g, '/'))
      if (isNaN(d.getTime())) {
        return ''
      }
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return this.$t('yyyy年MM月dd日')
        .replace('yyyy', d.getFullYear())
        .replace('MM', pad(d.getMonth() + 1))
        .replace('dd', pad(d.getDate()))
    },
  },
  methods: {
    edit(record) {
      this.visible = true
      this.title = this.$t('打印预览')
      this.disableSubmit = true
      this.model = Object.assign({}, record)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      this.close()
    },
  },
}
</script>
<style lang="less" scoped>
#a4-page-placeholder {
  color: #000;
}

#printCardContent {
  color: #000;
  background: #fff;
  width: 210mm;   /* A4 宽度 */
  min-height: 297mm; /* A4 高度 */
  padding: 12mm 14mm;
  margin: 0 auto;
  box-sizing: border-box;
  font-size: 14px;

  .title {
    text-align: center;
    font-size: 22px;
    font-weight: 800;
    margin-bottom: 10px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #000;
    height: 26px;
    padding: 2px 6px;
  }

  .info-table,
  .base-table {
    margin-bottom: 0;
  }

  .info-table td,
  .base-table td {
    height: 30px;
  }

  .no-border-table td,
  .no-border-table th {
    border: none;
    background: transparent;
  }

  .label {
    text-align: center;
    font-weight: 600;
    //background: #f5f5f5;
  }

  .center {
    text-align: center;
  }

  .month-table {
    th {
      text-align: center;
      font-weight: 600;
    }

    td {
      text-align: center;
    }

    .month-cell {
      font-weight: 600;
    }
  }
}
/* 打印样式：A4 单页 */
@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  body * {
    visibility: hidden;
  }

  #printCardContent,
  #printCardContent * {
    visibility: visible;
  }

  #printCardContent {
    position: absolute;
    left: 0;
    top: 0;
    width: 210mm;
    min-height: 297mm;
    margin: 0;
    padding: 12mm 14mm;
  }
}
</style>
